export default "# Main Menu\n\n# Column\n\n::demo{name=column}\n\n# GameID\n\n::demo{name=gameId}"